"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var LoadDataController =
/*#__PURE__*/
function () {
  function LoadDataController(loadDataSuccessCallback, lang) {
    _classCallCheck(this, LoadDataController);

    this.loadDataSuccessCallback = loadDataSuccessCallback;
    this.lang = lang;
    this.categoriesList = null;
    this.productsList = null;
    this.promotionsList = null;
    this.API_CS = 'https://creativenow.cz/projekty/canon/19-rozcestnik/api/export/';
    this.API_SK = 'https://creativenow.cz/projekty/canon/19-rozcestnik/api/export/sk';
    this.API_URL = lang === 'sk' ? this.API_SK : this.API_CS;
    this.initLoadData();
  }

  _createClass(LoadDataController, [{
    key: "initLoadData",
    value: function initLoadData() {
      var _this = this;

      $.ajax({
        url: this.API_URL,
        type: 'GET',
        contentType: 'application/x-www-form-urlencoded',
        success: function success(data) {
          _this.categoriesList = data.categories;
          _this.productsList = data.products;
          _this.promotionsList = data.promotions;

          _this.loadDataSuccessCallback();
        }
      });
    }
  }]);

  return LoadDataController;
}();